// src/api/carousel.api.js

import axios from './axios';

// 取得所有輪播圖
export function getAllCarousels() {
    return axios.get('/api/carousels').then(res => res.data);
}

// 新增輪播圖
export function createCarousel(carousel) {
    return axios.post('/api/carousels', carousel).then(res => res.data);
}

// 更新輪播圖
export function updateCarousel(id, carousel) {
    return axios.put(`/api/carousels/${id}`, carousel).then(res => res.data);
}

// 刪除輪播圖
export function deleteCarousel(id) {
    return axios.delete(`/api/carousels/${id}`).then(res => res.status === 200 || res.status === 204);
}
